import { DropdownContainer, ItemsPageLabel } from '../styled-components.js'
import DropdownComponent from '../../../../../molecules/dropdown/index.jsx'
import { dropdownBoxStyleOptions } from '../../../../../molecules/dropdown/constants.js'
import { tableItemsPerPageOptions } from '../../../constants.js'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { ToolbarPagesContainer } from '../../../styled-components.js'

const ToolbarPageSize = ({
  pageSize = null,
  onChangePageSize,
  disabled = false,
  ...props
}) => {
  const { formatMessage } = useIntl()

  const selectedPageSize =
    typeof pageSize === 'number'
      ? (tableItemsPerPageOptions.find((option) => option.title === pageSize) ??
        tableItemsPerPageOptions[0])
      : (pageSize ?? tableItemsPerPageOptions[0])

  const handleSelectedPageSize = (value) => {
    const nextPageSize = Number(value?.title)

    if (!nextPageSize) return

    onChangePageSize?.(nextPageSize)
  }

  return (
    <ToolbarPagesContainer {...props}>
      <ItemsPageLabel>{formatMessage({ id: 'items_per_page' })}</ItemsPageLabel>
      <DropdownContainer>
        <DropdownComponent
          disabled={disabled}
          boxStyle={dropdownBoxStyleOptions.MINIMAL}
          options={tableItemsPerPageOptions}
          defaultValue={selectedPageSize}
          customOnChange={handleSelectedPageSize}
          noEmptyField
          closeWhenSelected
          menuProps={{
            width: '70px'
          }}
        />
      </DropdownContainer>
    </ToolbarPagesContainer>
  )
}

ToolbarPageSize.propTypes = {
  pageSize: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.number.isRequired
    })
  ]),
  onChangePageSize: PropTypes.func
}

export default ToolbarPageSize
